import React, { lazy, Suspense } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import image from '../images/a347ce99-9901-4361-953e-f3306909469c.JPG';

const SimpleCarousel = lazy(() => import('../components/SimpleCarousel'));

const Post = ({ title, link, time, dateTime }) => (
  <article className="post format-link">
      <div className="inner">
          <h2 className="entry-title">
              <a href={link} title={title}>{title}</a>
          </h2>
          <ul className="meta top">
              <li className="time">
                  <a href={link} title={title}>
                      <time dateTime={dateTime}>{time}</time>
                  </a>
              </li>
          </ul>
      </div>
  </article>
);

const HomePage = () => {
  const aStyle = {
    color: '#FFF'
  };

  const navigate = useNavigate(); // Initialisation du hook useNavigate

  // Fonction de redirection
  const handleRSVPClick = () => {
    navigate('/wedding-rsvp'); // Redirection vers la page RSVP
  };

  return (
    <div>
      <div className="hero" style={{ backgroundImage: `url(${image})` }}>
        <div className="hero-inner">
          <div className="inner">
            <h1><span className="border border-top border-bottom">Mariage de Leslie & Loïc</span></h1>
            <div className="hero-line-two">
              <span className="border border-bottom">
                <Link to="/" style={aStyle}>le 14 Juin 2025</Link>
              </span>
            </div>
          </div>
          <Link className="more-arrow" to="#content">
            <i className="fa fa-chevron-down"></i>
            <span>Scroll Down</span>
          </Link>
        </div>
      </div>

      <div className="wrap full-wrap">
        <div className="main-wrap">
          <section className="main main-archive" style={{textAlign: 'center'}}>
            <button type="submit" onClick={handleRSVPClick}>
              Confirmer ma présence au mariage
            </button>
          </section>
        </div>
      </div>

      {/* Use Suspense for Lazy Loading */}
      <Suspense fallback={<div>Loading...</div>}>
        <SimpleCarousel />
      </Suspense>

      <div className="wrap full-wrap">
        <div className="main-wrap">
          <section className="main main-archive">
            <div className="loop" style={{paddingTop: '2em'}}>

              <Post title="Cérémonie Laïque" link="#" time="16h-17h" dateTime="2025-06-14" />
              <Post title="Cocktail & Ateliers culinaires" link="#" time="17h-21h" dateTime="2025-06-14" />
              <Post title="Dîner Assis" link="#" time="21h-23h00" dateTime="2025-06-14" />
              <Post title="Soirée" link="#" time="23h00 - Nuit" dateTime="2025-06-14" />

            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
